"use strict";

module.exports = function () {
	var sign = Math.sign;
	if (typeof sign !== "function") return false;
	return (sign(10) === 1) && (sign(-20) === -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/math/sign/is-implemented.js
// module id = 702
// module chunks = 0